/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Membersremovetitle2Inputs */

const en_membersremovetitle2 = /** @type {(inputs: Membersremovetitle2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.name}?`)
};

const de_membersremovetitle2 = /** @type {(inputs: Membersremovetitle2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} entfernen?`)
};

/**
* | output |
* | --- |
* | "Remove {name}?" |
*
* @param {Membersremovetitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersremovetitle2 = /** @type {((inputs: Membersremovetitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersremovetitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersremovetitle2(inputs)
	return de_membersremovetitle2(inputs)
});
export { membersremovetitle2 as "membersRemoveTitle" }